/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1SMQueryItem } from './V1SMQueryItem'
import {
    V1SMQueryItemFromJSON,
    V1SMQueryItemFromJSONTyped,
    V1SMQueryItemToJSON,
    V1SMQueryItemToJSONTyped
} from './V1SMQueryItem'

/**
 *
 * @export
 * @interface V1SMQueryResult
 */
export interface V1SMQueryResult {
    /**
     *
     */
    items: Array<V1SMQueryItem>
}

/**
 * Check if a given object implements the V1SMQueryResult interface.
 */
export function instanceOfV1SMQueryResult(
    value: object
): value is V1SMQueryResult {
    if (!('items' in value) || value['items'] === undefined) return false
    return true
}

export function V1SMQueryResultFromJSON(json: any): V1SMQueryResult {
    return V1SMQueryResultFromJSONTyped(json, false)
}

export function V1SMQueryResultFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1SMQueryResult {
    if (json == null) {
        return json
    }
    return {
        items: (json['items'] as Array<any>).map(V1SMQueryItemFromJSON)
    }
}

export function V1SMQueryResultToJSON(json: any): V1SMQueryResult {
    return V1SMQueryResultToJSONTyped(json, false)
}

export function V1SMQueryResultToJSONTyped(
    value?: V1SMQueryResult | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items: (value['items'] as Array<any>).map(V1SMQueryItemToJSON)
    }
}
